const { setting, network } = require('./')
module.exports = Object.assign({}, setting, network)
